export default {
    lists: [
        // '/',
        // '/index',
        // '/distribution/chat',
        '/distribution/goodscomb',
        '/distribution/goodsdetail',
        '/sharedetail',
        '/update',
        '/login',
        '/register',
        '/bind_wechat',
        '/goodsdetail_share',
        '/distribution/help/details',
        '/yunindex',
        '/goods_promote',
        '/download',
        '/distribution/exchange/index',
        '/marketing/help/index/index',
        '/marketing/help/introduced/index',
        '/marketing/help/joinapply/index',
        '/retail/order/activitydetail',
        '/distribution/activity/details',
        '/agreement',
        '/common_register',
        '/default_register',
        '/binding/setloginpwd',
        '/binding/bindsuperior',
        '/distribution/activity/map'
        // '/distribution/wallet/ticketconfirm'
    ],
    isUrl: function(url, type) {
        let sym = '==';
        if (type) {
            sym = type;
        }
        let that = this;
        let noLoginUrls = '';
        for (var i = 0; i < that.lists.length; i++) {
            if (i == 0) {
                noLoginUrls += '"' + url + '"' + sym + '"' + that.lists[i] + '"';
            } else {
                noLoginUrls += '||' + '"' + url + '"' + sym + '"' + that.lists[i] + '"';
            }
        }
        return eval(noLoginUrls);
    }
}


// WEBPACK FOOTER //
// ./src/routes/nologin.js